import React, { useMemo, useCallback } from "react";

import { TeamID } from "../../types";

import { useTeamImgProps } from "../teamImage";

interface TeamFilterButtonProps {
  teamId: TeamID;
  toggle: (teamId: TeamID) => void;
  markUnselected?: boolean;
}

export const TeamFilterButton = ({
  teamId,
  toggle,
  markUnselected,
}: TeamFilterButtonProps) => {
  const getTeamImageProps = useTeamImgProps();

  const className = useMemo(() => {
    return [
      "neo__lineupPicker__teamFilter__button",
      markUnselected ? "neo__lineupPicker__teamFilter__button--markUnselected" : "",
    ].join(" ");
  }, [markUnselected]);

  const onClick = useCallback(() => {
    toggle(teamId);
  }, [toggle, teamId]);

  return (
    <a className={className} onClick={onClick}>
      <span>
        <img {...getTeamImageProps(teamId)} />
      </span>      
    </a>
  );
};
